import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { useField } from 'formik';
import { IHubspotField } from '../../../../../models/hubspot-forms';
import { stripHtml } from '../../../util';

interface DropdownFieldAdapterProps {
  field: IHubspotField;
}

export const DropdownFieldAdapter: React.FC<DropdownFieldAdapterProps> = ({ field }) => {
  const [formikField, meta] = useField(field.name);

  if (field.hidden) {
    return null;
  }

  // Extract validation error state
  const showError = meta.touched && Boolean(meta.error);
  const label = stripHtml(field.label) || field.name;

  return (
    <FormControl fullWidth margin="dense" error={showError}>
      <InputLabel id={`${field.name}-label`} shrink>
        {label}
        {field.required && ' *'}
      </InputLabel>
      <Select
        {...formikField}
        labelId={`${field.name}-label`}
        id={field.name}
        name={field.name}
        label={label}
        displayEmpty
      >
        {!field.required && (
          <MenuItem value="">
            <em>Select an option</em>
          </MenuItem>
        )}
        {field.options?.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {showError && <FormHelperText>{meta.error}</FormHelperText>}
    </FormControl>
  );
};
